import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CollectionSelect from 'components/application/CollectionSelect';
import Tooltip from 'components/application/Tooltip';

import { useCurrentActor } from 'components/contexts/CurrentActor';

import { formatCompanyOption } from 'components/helpers/companies';

export default function SelectDivision({
  assignedDivision,
  collectionSelectProps = {},
  companies,
  label,
  onChange,
  sidePanelContext,
}) {
  const {
    division: {
      attributes: { primary: isPrimaryDivision },
      id: currentDivisionId,
    },
  } = useCurrentActor();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'personnel.SelectDivision',
  });

  const primaryDivision = companies.find(
    (company) => company.attributes.primary,
  );

  useEffect(() => {
    if (sidePanelContext === 'new') {
      onChange(
        { value: { companyId: currentDivisionId, subcontractorId: '' } },
        { action: 'select-option', option: undefined, name: 'company' },
      );
    }
  }, []);

  const assignableOptions = () =>
    companies.map((company) => formatCompanyOption(company));

  const companyValue =
    assignedDivision ? formatCompanyOption(assignedDivision) : '';

  return (
    <div className='tooltip-parent tw-ml-7.5'>
      <CollectionSelect
        isDisabled={!isPrimaryDivision}
        isRequired={true}
        isSearchable={true}
        label={label}
        modifiers={['typeable-search']}
        name='company'
        onChange={onChange}
        options={assignableOptions()}
        value={companyValue}
        {...collectionSelectProps}
      />
      {!isPrimaryDivision && (
        <Tooltip
          className='tw-top-6'
          placement='top'
          tooltip={i18nT('disabledTooltip', {
            interpolation: { escapeValue: false },
            primaryDivisionName: primaryDivision.attributes.name,
          })}
          trigger='hover'
        />
      )}
    </div>
  );
}

SelectDivision.propTypes = {
  sidePanelContext: PropTypes.string.isRequired,
  companies: PropTypes.array.isRequired,
  collectionSelectProps: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};
